{
  "version": 1,
  "asset_id": "d4ff47d5-fe76-4834-96a6-cdfab317e2ce",
  "project_id": "765508a6-9c9d-45ab-81ce-ecfbc5eb2942",
  "url": "/__l5e/assets-v1/d4ff47d5-fe76-4834-96a6-cdfab317e2ce/Experience.png",
  "r2_key": "a/v1/765508a6-9c9d-45ab-81ce-ecfbc5eb2942/d4ff47d5-fe76-4834-96a6-cdfab317e2ce/Experience.png",
  "original_filename": "Experience.png",
  "size": 484532,
  "content_type": "image/png",
  "created_at": "2026-08-18T18:27:17Z"
}
